import { h } from "preact";

/**
 * Табы продуктов.
 *
 * Пропсы:
 *   products  — { pvd: { title }, craft: { title }, zip: { title } }
 *   productId — текущий выбранный id
 *   onchange  — колбэк (id) => void
 */
export function ProductSelector({ products, productId, onchange }) {
  return h("div", { class: "product-selector" },
    Object.entries(products).map(([id, { title }]) => {
      const isActive = productId === id;
      return h("button", {
        key: id,
        type: "button",
        class: "product-selector__tab" + (isActive ? " is--active" : ""),
        onClick: () => onchange(id),
      }, title);
    })
  );
}
